import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { LegaleIncaricato } from '../../../models/legale-incaricato';

@Component({
    selector: '[legale_incaricato_entity_view]',
  templateUrl: 'legale-incaricato-entity-view.component.html',
})

export class LegaleIncaricatoEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element: LegaleIncaricato;
}
